import * as React from "react";

import { NavigationToggle } from "@/shared/components/NavigationToggle";

import { RobotoTopBarActions } from "../RobotoNavigation/RobotoTopBar";

import styles from "./PageLayout.module.css";

export interface PageLayoutProps extends React.PropsWithChildren {
  title?: string;
  headerContentLeft?: React.ReactNode | string;
  headerContentRight?: React.ReactNode | string;
}

export function PageLayout(props: PageLayoutProps) {
  React.useEffect(
    function setPageTitle() {
      if (props.title) {
        document.title = props.title;
      } else {
        document.title = "Roboto";
      }
    },
    [props.title],
  );

  return (
    <main className={styles.page}>
      <header className={styles.pageHeader}>
        <div className={styles.pageHeaderLeft}>
          <NavigationToggle />
          <h1 className={styles.pageHeaderTitle}>{props.headerContentLeft}</h1>
        </div>
        <div className={styles.pageHeaderRight}>
          {props.headerContentRight}
          <div className={styles.rightActionsContainer}>
            {props.headerContentRight && <div className={styles.spacer} />}
            <RobotoTopBarActions />
          </div>
        </div>
      </header>
      <div className={styles.pageContent}>{props.children}</div>
    </main>
  );
}
